import { render, staticRenderFns } from "./DeliveryNoticeDetailUnHandleList.vue?vue&type=template&id=2510ce6a&"
import script from "./DeliveryNoticeDetailUnHandleList.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoticeDetailUnHandleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports